import React from 'react'
import ToolbarButton from '../Page/ToolbarButton'
import PolygonIcon from './PolygonIcon'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import MyLocationIcon from '@material-ui/icons/MyLocation'
import SearchIcon from '@material-ui/icons/Search'
import { useMatomo } from '@datapunt/matomo-tracker-react'

// import Matomo  from '../Analysis/Matomo'

export default ({
	useGeolocation,
	isInSelectMode,
	onZoomInClick,
	onZoomOutClick,
	onGeolocationClick,
	onPolygonClick,
	onSearchClick
}) => {
	const { trackEvent } = useMatomo()
	return (
		<React.Fragment>
				<ToolbarButton
					title="Zooma in"
					icon={<AddIcon />}
					onClick={onZoomInClick}
					style={{ flex: '1 1 auto' }}
				/>
				<ToolbarButton
					title="Zooma ut"
					icon={<RemoveIcon />}
					onClick={onZoomOutClick}
					style={{ flex: '1 1 auto' }}
				/>
				<ToolbarButton
					title="Zooma till min position"
					icon={<MyLocationIcon />}
					onClick={() => {trackEvent({ category: 'Kartverktyg', action: 'Zooma till min position',name: 'onClick'});onGeolocationClick()}}
					disabled={!useGeolocation}
					style={{ flex: '1 1 auto' }}
				/>
				<ToolbarButton
					title="Välj med polygon"
					icon={<PolygonIcon />}
					onClick={() => {trackEvent({ category: 'Kartverktyg', action: 'Välj med polygon',name: 'onClick'});onPolygonClick()}}
					active={isInSelectMode}
					style={{ flex: '1 1 auto' }}
				/>
				<ToolbarButton
					title="Sök stompunkt"
					icon={<SearchIcon />}
					onClick={() => {trackEvent({ category: 'Kartverktyg', action: 'Sök stompunkt',name: 'onClick'});onSearchClick()}}
					style={{ flex: '1 1 auto' }}
				/>
		</React.Fragment>
);}



// WEBPACK FOOTER //
// ./src/components/MapMenu/MapControls.js